import React from "react";

const HisEye = ({ color = "#708FBB", sx = {} }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg style={_sx} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.30078 12.1016C2.30078 12.1016 5.30078 5.10156 12.3008 5.10156C19.3008 5.10156 22.3008 12.1016 22.3008 12.1016C22.3008 12.1016 19.3008 19.1016 12.3008 19.1016C5.30078 19.1016 2.30078 12.1016 2.30078 12.1016Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3008 15.1016C13.9576 15.1016 15.3008 13.7584 15.3008 12.1016C15.3008 10.4447 13.9576 9.10156 12.3008 9.10156C10.6439 9.10156 9.30078 10.4447 9.30078 12.1016C9.30078 13.7584 10.6439 15.1016 12.3008 15.1016Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisEye;
